import React from 'react';
import { Panel } from '@tanium/react-panel';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';
import { DefinitionList, DefinitionListItem } from '@tanium/react-definition-list';
import { Link } from '@tanium/react-link';
import MediumText from 'components/styles/text/MediumText';
import MediumBoldText from 'components/styles/text/MediumBoldText';
import Helper from 'utils/Helper';
import { MsEntraID } from 'gql/MsEntraID';

export interface IMsEntraIDDetailProps {
  msEntraID: MsEntraID;
}

export const MsEntraIDDetails = ({ msEntraID }: IMsEntraIDDetailProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      <Panel title={t('MS_ENTRA_ID_DETAILS')}>
        <Box pl={7}>
          <Stack itemSpacing={10} direction="columns">
            <DefinitionList>
              <DefinitionListItem
                term={<MediumText>{t('ID')}:</MediumText>}
                description={<MediumBoldText>{msEntraID.id}</MediumBoldText>}
              />
              {msEntraID.name && (
                <DefinitionListItem
                  term={<MediumText>{t('NAME')}:</MediumText>}
                  description={<MediumBoldText>{msEntraID.name}</MediumBoldText>}
                />
              )}
              {msEntraID.description && (
                <DefinitionListItem
                  term={<MediumText>{t('DESCRIPTION')}:</MediumText>}
                  description={<MediumBoldText>{msEntraID.description}</MediumBoldText>}
                />
              )}
              {msEntraID.tenantID && (
                <DefinitionListItem
                  term={<MediumText>{t('TENANT_ID')}:</MediumText>}
                  description={<MediumBoldText>{msEntraID.tenantID}</MediumBoldText>}
                />
              )}
              {msEntraID.tier && (
                <DefinitionListItem
                  term={<MediumText>{t('TIER')}:</MediumText>}
                  description={<MediumBoldText>{msEntraID.tier}</MediumBoldText>}
                />
              )}
            </DefinitionList>
            <DefinitionList>
              {msEntraID.createdBy && (
                <DefinitionListItem
                  term={<MediumText>{t('CREATED_BY')}:</MediumText>}
                  description={
                    <Link href={msEntraID?.createdBy}>
                      <MediumBoldText>{msEntraID?.createdBy}</MediumBoldText>
                    </Link>
                  }
                />
              )}
              {msEntraID.createdAt && (
                <DefinitionListItem
                  term={<MediumText>{t('CREATED_AT')}:</MediumText>}
                  description={<MediumBoldText>{Helper.localDateIn12HrFormat(msEntraID.createdAt)}</MediumBoldText>}
                />
              )}
            </DefinitionList>
          </Stack>
        </Box>
      </Panel>
    </>
  );
};

export default MsEntraIDDetails;
